import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-create-task-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class TaskUploadTaskDataApiManualV2Component extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Create New Task",
            description: "This endpoint can be used to create a new task.",
            httpMethod: "POST",
            path: "/taskdata/v2/tasks",

            parameters: [
                {
                    name: "name",
                    description: "name of the task to create",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "task to create name",
                },
                {
                    name: "description",
                    description: "description of the task to create",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "task description",
                },
                {
                    name: "responsibles",
                    description: "uuid's of the users to be assigned as responsible to the task",
                    in: "body",
                    paramType: "array of uuid's",
                    required: true,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000",
                    ],
                },
                {
                    name: "reviewers",
                    description: "uuid's of the users to be assigned as reviewers to the task",
                    in: "body",
                    paramType: "array of uuid's",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000",
                    ],
                },
                {
                    name: "actionDate",
                    description: "the action Date of the task",
                    in: "body",
                    paramType: "date",
                    required: true,
                    example: "2021-07-21",
                },
                {
                    name: "linkedControl",
                    description: "the uuid of the control to which the task is linked",
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "comments",
                    description: "the comments on the task",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "comment on the task",
                },
                {
                    name: "notifications",
                    description: `the notifications for the task:
                                    -2: 3 months in advance
                                    -1: 2 months in advance
                                    1: 1 month in advance
                                    2: 3 weeks in advance
                                    3: 2 weeks in advance
                                    4: 1 week in advance
                                    5: 1 day in advance
                                    11: On due date
                                    6: 1 day in overdue
                                    7: 1 week in overdue
                                    8: 2 weeks in overdue
                                    9: 3 weeks in overdue
                                    10: 1 month in overdue
                                    12: 2 months in overdue
                                    13: 3 months in overdue`,
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [4, 5, 11],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
